import React from "react";

import { Button, ButtonGroup, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

import { useAppDispatch, useAppSelector } from "store";
import { CostMeasureType as CostMeasureTypeEnum, selectCostCorrelationsCostMeasureType, setCostCorrelationsCostMeasureType } from "modules/customer/insights/cost/costDrivers/costDriversSlice";

const StyledButtonGroup = withStyles(theme => ({
    root: {
        // @ts-ignore
        backgroundColor: theme.palette.quaternary.dark,
        marginBottom: theme.spacing(2),
        borderRadius: "6px"
    },
}))(ButtonGroup);

const StyledButton = withStyles(theme => ({
    root: {
        // @ts-ignore
        backgroundColor: (props: any) => props["data-is-selected"] ? theme.palette.quaternary.light : theme.palette.quaternary.dark,
        color: theme.palette.common.white,
        borderRadius: "6px",
        "&:hover": {
            // @ts-ignore
            backgroundColor: (props: any) => props["data-is-selected"] ? theme.palette.quaternary.light : theme.palette.quaternary.dark,
            color: theme.palette.common.white,
        },
        "&.MuiButtonGroup-groupedHorizontal:not(:firs-child)": {
            border: 0,
            borderRadius: "6px"
        },
        "&.MuiButtonGroup-groupedHorizontal:not(:last-child)": {
            border: 0,
            borderRadius: "6px"
        },
        "&.MuiButtonGroup-groupedContainedHorizontal:not(:first-child)": {
            border: 0,
            borderRadius: "6px"
        },
        "&.MuiButtonGroup-groupedContainedHorizontal:not(:last-child)": {
            border: 0,
            borderRadius: "6px"
        }
    }
}))(Button);

const CostMeasureType: React.FC = () => {
    const dispatch = useAppDispatch();
    const costMeasureType = useAppSelector(selectCostCorrelationsCostMeasureType);

    const handleCostValueClick = () => {
        dispatch(setCostCorrelationsCostMeasureType(CostMeasureTypeEnum.CostValue));
    };

    const handlePercentageClick = () => {
        dispatch(setCostCorrelationsCostMeasureType(CostMeasureTypeEnum.CostAsPercentageOfRevenue));
    };

    return (
        <StyledButtonGroup
            variant="contained"
            size="medium"
            color="default"
            disableElevation
        >
            <StyledButton
                data-is-selected={costMeasureType === CostMeasureTypeEnum.CostValue}
                onClick={handleCostValueClick}
            >
                <Typography variant="subtitle2" component="div">
                    Cost value
                </Typography>
            </StyledButton>
            <StyledButton
                data-is-selected={costMeasureType === CostMeasureTypeEnum.CostAsPercentageOfRevenue}
                onClick={handlePercentageClick}
            >
                <Typography variant="subtitle2" component="div">
                    Cost as a % of revenue
                </Typography>
            </StyledButton>
        </StyledButtonGroup>
    );
};

export default CostMeasureType;
